import {Component} from "react";
import "./AvvisiToBrowser.css";
import Glob from "../../../../../libs/Glob.mjs";
import Select from "react-select";
import {Button, ButtonGroup, Form, Input, InputGroup, InputGroupText, Label} from "reactstrap";
import CheckboxUncheckedIcon from "../../../../../media/images/CheckboxUncheckedIcon.mjs";
import CheckboxCheckedIcon from "../../../../../media/images/CheckboxCheckedIcon.mjs";
import TextLabel from "../../../../../Controls/TextLabel.mjs";
import ChecronRightIcon from "../../../../../media/images/ChevronRightIcon.mjs";
import ChevronLeftIcon from "../../../../../media/images/ChevronLeftIcon.mjs";
import CloseIcon from "../../../../../media/images/CloseIcon.mjs";
import MailIcon from "../../../../../media/images/MailIcon.mjs";

const prefix = "AvvisiToBrowser";

const AvvisiToBrowser = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: (props.value || props.message?.to || props.getter()?.to || []).filter( x => !! x ),
			filters: {},
			checked: [],
			selChecked: []
		};
		this.uid = Glob.generateUid(prefix);
		this.load = this.load.bind(this);
		this.setFilter = this.setFilter.bind(this);
		this.selected = this.selected.bind(this);
		this.checked = this.checked.bind(this);
		this.explode = this.explode.bind(this);
		this.addChecked  = this.addChecked.bind(this);
		this.save = this.save.bind(this);
		this.selEditFixed  = this.selEditFixed.bind(this);
		this.selAddFixed  = this.selAddFixed.bind(this);
	}
	componentDidMount() {
		setTimeout(this.load );
	}
	save() {
		const m = this.props.getter();
		m.to = this.state.value;
		this.props.setter(m);
		this.props.close();
	}
	load() {
		this.setState( {loading:true}, async ()=>{
			const ns = { loading: false };
			ns.axles = await Glob.api({entity:"admin",operation:"anagrafica-axles"},{ filters: this.state.filters });
			ns.options = {
				cliente:  (ns.axles?.cliente||[]).map(c => ({ label: c.ragionesociale, value: String(c.id) })),
				area: (ns.axles?.area||[]).map( a => ({ label: a, value: a })),
				ruolo: (ns.axles?.ruolo||[]).map( a => ({ label: a, value: a }))
			};
			Object.keys(ns.options).forEach(k => {
				ns.options[k].sort((a, b) => a.label.toLocaleLowerCase().localeCompare(b.label.toLocaleLowerCase()));
			});
			if ( ns.axles.utenti ) {
				ns.utenti = ns.axles.utenti
					.filter( u => ! this.state.value.includes( u.id ))
					.map( u => ({ value: u.id, label: `${u.nome} (${u.ruolo})` }))
					.sort((a, b) => a.label.toLocaleLowerCase().localeCompare(b.label.toLocaleLowerCase()));
				delete ns.axles.utenti;
				ns.checked = this.state.checked.filter( x => ns.utenti.find( u => u.value === x));
			} else {
				ns.utenti = false;
				ns.checked = [];
			}
			this.setState(ns, this.explode);
		});
	}
	async explode() {
		if ( this.state.value.length === 0 ) {
			this.setState({ selected: [], selChecked: [] });
			return;
		}
		const all = (( await Glob.api({entity:"admin", operation:"anagrafica-entries"}, {list: this.state.value}) )?.list)||[];
		const fixed = all
			.filter( x => typeof x === "string" && x.includes("@"))
			.sort((a, b) => a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()));
		const s = all
			.filter( u => !! u?.id )
			.map( u => ({ value: u.id, label: `${u.nome} (${u.ruolo})`, title: u.area ? `${u.area}, ${u.cliente}`: u.cliente }))
			.sort((a, b) => (a.label).toLocaleLowerCase().localeCompare(b.label.toLocaleLowerCase()));
		const sc = this.state.selChecked.filter( x => s.find( u => u.id === x));
		this.setState({ selected: fixed.concat(s), selChecked: sc });
	}
	setFilter( filterName, filterValue ) {
		const f = this.state.filters;
		if ( ! filterValue || (Array.isArray( filterValue ) && ! filterValue.length ) ) {
			delete f[filterName];
		} else {
			f[filterName] = filterValue;
		}
		this.setState({ filters: f }, this.load );
	}
	selected( field ) {
		const opts = ((this.state?.options||{})[field] || []);
		const fv = ( (this.state.filters||{})[field] || [] ).map( x => String(x) );
		return opts.filter( o => fv.includes( o.value ) );
	}
	checked( id, state ) {
		if ( typeof id === "string" ) id = Number(id);
		if ( ! (id && typeof id === "number") ) return;
		if ( typeof state !== "boolean" ) return ( this.state.value.includes( id ));
		const us = this.state.utenti;
		const idx = us.findIndex( u => u.value === id );
		if ( idx > -1 ) {
			us[idx].checked = state;
			let c = this.state.checked || [];
			if ( state ) {
				if ( ! c.includes( id ) ) c.push(id);
			} else if ( c.includes( id ) ) {
				c = c.filter( x => x !== id );
			}
			this.setState( { utenti: us, checked: c } );
		}
		return state;
	}
	addChecked() {
		const checked = this.state.checked||[];
		if ( ! checked.length ) return;
		const value = this.state.value||[];
		const users = this.state.utenti.filter( u => ! checked.includes(u.value) );
		value.push( ...checked.filter( c => (! value.includes(c))) );
		this.setState({ checked: [], utenti: users, value: value }, this.explode );
	}
	selChecked( id, state ) {
		if ( typeof id === "string" ) id = Number(id);
		if ( ! (id && typeof id === "number") ) return;
		const us = this.state.selected;
		const idx = us.findIndex( u => u.value === id );
		if ( idx > -1 ) {
			us[idx].checked = state;
			let c = this.state.selChecked || [];
			if ( state ) {
				if ( ! c.includes( id ) ) c.push(id);
			} else if ( c.includes( id ) ) {
				c = c.filter( x => x !== id );
			}
			this.setState( { selected: us, selChecked: c } );
		}
		return state;
	}
	selEditFixed( email ) {
		const src = this.state.selected||[];
		const fixed = src.filter( x => typeof x === "string" && x.includes("@"));
		const others = src.filter( x => !! x?.label );
		const idx = fixed.findIndex( x => x === email );
		if ( idx > -1 ) {
			const edit = (fixed.splice(idx, 1))[0];
			const values = fixed.concat( (this.state.value||[] ).filter( x => typeof x == 'number'));
			this.setState( { selected: fixed.concat(others), onEditEmail: edit, value: values  } );
		}
	}
	selAddFixed( email ) {
		const ns = { onEditEmail: "" };
		if ( email ) {
			const src = this.state.selected || [];
			const fixed = src.filter(x => typeof x === "string" && x.includes("@"))
				.concat(email)
				.sort((a, b) => a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()));
			const others = src.filter(x => !!x?.label);
			ns.selected = fixed.concat(others);
			ns.value = fixed.concat((this.state.value || []).filter(x => typeof x == 'number'));
		}
		this.setState(ns);
	}
	render() {
		return (
			<div className={prefix} id={"this.uid"}>
				<div className={'browser'}>
					<div className={'filters'}>
						<h4>
							<TextLabel value={"Filters"} />
						</h4>
						<div>
							<div>Cliente</div>
							<Select
								menuPortalTarget={document.body}
								styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
								isMulti={true}
								isClearable={true}
								placeholder={ Glob.label('Select…') }
								options={ this.state.options?.cliente || [] }
								value={ this.selected('cliente') }
								onChange={ x => { this.setFilter('cliente', x.map( c => parseInt(c.value) )); }}
							/>
						</div>
						<div>
							<div>Area</div>
							<Select
								menuPortalTarget={document.body}
								styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
								isMulti={true}
								isClearable={true}
								placeholder={ Glob.label('Select…') }
								options={ this.state.options?.area || [] }
								value={ this.selected('area') }
								onChange={ x => { this.setFilter('area', x.map( c => c.value )); }}
							/>
						</div>
						<div>
							<div>Ruolo</div>
							<Select
								menuPortalTarget={document.body}
								styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
								isMulti={true}
								isClearable={true}
								placeholder={ Glob.label('Select…') }
								options={ this.state.options?.ruolo || [] }
								value={ this.selected('ruolo') }
								onChange={ x => { this.setFilter('ruolo', x.map( c => c.value )); }}
							/>
						</div>
					</div>
					<div className={'utenti'}>
						<h4>
							<TextLabel value={"QtFound"} params={{qt:(this.state.utenti||[]).length}} />
						</h4>
						{ this.state.utenti && this.state.utenti.length > 0 && (
							<>
								<div className={"list"}>
									{this.state.utenti.map( ( u,i) => (
										<div
											key={i}
											className={ u?.checked ? 'checked' : 'unchecked' }
											onClick={ ()=>{ this.checked(u?.value, ! u?.checked ) }}
										>
											{ u?.checked ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon /> }
											<Label>{ u.label }</Label>
										</div>
									))}
								</div>
								<div className={"controls"}>
									<ButtonGroup className="btn-icon">
										<Button
											disabled={ (this.state.checked||[]).length === 0 }
											onClick={ ()=> {
												const us = this.state.utenti;
												us.forEach( u => delete u.checked );
												this.setState( { utenti: us, checked: [] } );
											}}
										>
											<i>
												<CheckboxUncheckedIcon />
											</i>
										</Button>
										<Button
											disabled={ (this.state.checked||[]).length === (this.state.utenti||[]).length }
											onClick={ ()=> {
												const us = this.state.utenti;
												const c = [];
												us.forEach( u => {
													u.checked = true;
													c.push(u.value);
												});
												this.setState( { utenti: us, checked: c } );
											}}
										>
											<i>
												<CheckboxCheckedIcon />
											</i>
										</Button>
										<Button
											disabled={ this.state.checked.length === 0 }
											color={"primary"}
											onClick={ this.addChecked }
										>
											<b>
												{ this.state.checked.length }
											</b>
											<i>
												<ChecronRightIcon />
											</i>
										</Button>
									</ButtonGroup>
								</div>
							</>
						)}
					</div>
					<div className={'utenti selected'}>
						<h4>
							<TextLabel value={"QtRecipients"} params={{qt:(this.state.value||[]).length}} />
						</h4>
						{ this.state.selected && this.state.selected.length > 0 && (
							<>
								<div className={"list"}>
									{ this.state.selected.filter( u => typeof u === "string").map( ( u,i) => (
										<div
											key={'e'+i}
											onClick={ ()=>{ this.selEditFixed(u) }}
										>
											<MailIcon />
											<Label>{ u }</Label>
										</div>
									))}
									{ this.state.selected.filter( u => !! u?.label ).map( ( u,i) => (
										<div
											key={'u'+i}
											title={`${u.label}\n${u.title}`}
											className={ u?.checked ? 'checked' : 'unchecked' }
											onClick={ ()=>{ this.selChecked(u?.value, ! u?.checked ) }}
										>
											{ u?.checked ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon /> }
											<Label>{ u.label }</Label>
										</div>
									))}
								</div>
								{ this.state.selected.filter( u => !! u?.label ).length > 0 && (
									<div className={"controls"}>
										<ButtonGroup className="btn-icon">
											<Button
												color={"warning"}
												disabled={ (this.state.selChecked||[]).length === 0 }
												onClick={ ()=> {
													const us = this.state.value.filter( u => ! this.state.selChecked.includes(u) );
													this.setState( { value: us, selChecked: [] }, this.load );
												}}
											>
												<i>
													<ChevronLeftIcon />
												</i>
												<b>
													{ (this.state.selChecked||[]).length }
												</b>
											</Button>
											<Button
												disabled={ (this.state.selChecked||[]).length === 0}
												onClick={ ()=> {
													const s = this.state.selected;
													s.filter( u => typeof u === 'object' ).forEach( u => { delete u.checked ; } );
													this.setState( { selected: s, selChecked: [] } );
												}}
											>
												<i>
													<CheckboxUncheckedIcon />
												</i>
											</Button>
											<Button
												disabled={ (this.state.selChecked||[]).length === (this.state.value||[]).length }
												onClick={ ()=> {
													const s = this.state.selected;
													const c = [];
													s.filter( u => typeof u === 'object' ).forEach( u => { u.checked=true; c.push(u.value); } );
													this.setState( { selected: s, selChecked: c } );
												}}
											>
												<i>
													<CheckboxCheckedIcon />
												</i>
											</Button>
										</ButtonGroup>
									</div>
								)}
							</>
						)}
					</div>
				</div>
				<Form
					className={"browserFooter"}
					onSubmit={ (e) => {
						e.preventDefault();
						if ( (this.state.onEditEmail||'').match(/^[^ @]+@([^ @.]+\.)+[^ @.]{2,}$/) ) {
							this.selAddFixed(this.state.onEditEmail)
						}
					}}
				>
					<span />
					<InputGroup className={"emailEditArea"}>
						<InputGroupText>@</InputGroupText>
						<Input
							type={"text"}
							placeholder={ Glob.label("Manual e-mail address") }
							value={ this.state.onEditEmail || '' }
							onChange={ (e) => { this.setState({ onEditEmail: e.target.value }); } }
						/>
						<Button
							type={"reset"}
							disabled={ ! this.state.onEditEmail }
							onClick={ ()=> { this.selAddFixed() }}
						>
							<CloseIcon />
						</Button>
						<Button
							type={"submit"}
							disabled={ ! (this.state.onEditEmail||'').match(/^[^ @]+@([^ @.]+\.)+[^ @.]{2,}$/) }
							color={"primary"}
						>
							<ChecronRightIcon />
						</Button>
					</InputGroup>
					<ButtonGroup className="btn-icon">
						<Button
							type={"button"}
							disabled={ (this.state.value||[]).length === 0}
							color={"success"}
							onClick={ this.save }
						>
							<b>
								<TextLabel value={"OK"} />
							</b>
							<i>
								<TextLabel value={"ok"} lang={"icon"} />
							</i>
						</Button>
					</ButtonGroup>
				</Form>
			</div>
		)
	}
}

export default AvvisiToBrowser;
